(() => {
  const root = document.querySelector('[data-accessory-product]');
  if (!root) return;

  const stageImage = root.querySelector('[data-gallery-stage-image]');
  root.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!stageImage) return;
      stageImage.src = thumb.dataset.fullSrc;
      stageImage.alt = thumb.dataset.alt || '';
      root.querySelectorAll('[data-gallery-thumb]').forEach((item) => {
        const active = item === thumb;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
    });
  });

  const variantId = root.querySelector('[data-variant-id]');
  const price = root.querySelector('[data-product-price]');
  const comparePrice = root.querySelector('[data-compare-price]');
  const addButton = root.querySelector('[data-add-to-cart]');
  const addText = root.querySelector('[data-add-to-cart-text]');
  const dynamicCheckout = root.querySelector('[data-dynamic-checkout]');
  root.querySelectorAll('[data-variant-option]').forEach((option) => {
    option.addEventListener('change', () => {
      if (!option.checked) return;
      if (variantId) variantId.value = option.value;
      if (price) price.textContent = option.dataset.price || '';
      if (comparePrice) {
        comparePrice.textContent = option.dataset.comparePrice || '';
        comparePrice.classList.toggle('is-hidden', !option.dataset.comparePrice);
      }
      const available = option.dataset.available === 'true';
      if (addButton) addButton.disabled = !available;
      if (addText) addText.textContent = available ? 'Add to Cart' : 'Sold out';
      if (dynamicCheckout) {
        dynamicCheckout.toggleAttribute('inert', !available);
        dynamicCheckout.setAttribute('aria-disabled', String(!available));
      }
    });
  });

  const quantity = root.querySelector('[data-quantity-input]');
  root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
    if (!quantity) return;
    quantity.value = String(Math.max(1, Number(quantity.value || 1) - 1));
  });
  root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
    if (!quantity) return;
    quantity.value = String(Math.max(1, Number(quantity.value || 1) + 1));
  });
})();
